module.exports = __webpack_public_path__ + "img/zl.bef31d64.jpg";